import classNames from "classnames";
import { format } from "date-fns";
import Encoding from "encoding-japanese";
import Papa from "papaparse";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { BiDownload } from "react-icons/bi";
import { toast } from "react-toastify";
import { Api } from "../../../../services/api";
//import { Paginator } from "primereact/paginator";

function ErrorReportDialog({ close, reportInfo }) {
  const [errorData, setErrorData] = useState([]);
  const [currentKeys, setCurrentKeys] = useState([]);
  const [fileCSV, setFileCSV] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getReport()
  }
    , [])

  const getReport = async () => {
    setLoading(true)
    try {
      const { data } = await Api.get(`/cargacobrancas/relatorioCarga?carga_id=${reportInfo.carga_id}`)
      const unicodeData = formatChar(data.base64_relatorio);
      const newFile = new File([unicodeData], 'prefectures.txt', {
        type: 'text/csv',
      });
      setFileCSV(newFile);
      parseFile(newFile);
    } catch (error) {
      console.log(error)
      toast.error('Erro de conexão com o sistema, tente novamente mais tarde!')
    }
    finally {
      setLoading(false)
    }
  }

  function formatChar(base64) {
    const binaryString = atob(base64);
    const arrayBuffer = new ArrayBuffer(binaryString.length);
    const view = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryString.length; i++) {
      view[i] = binaryString.charCodeAt(i);
    }

    const encodingType = Encoding.detect(view);
    const unicodeArray = Encoding.convert(view, {
      to: "UNICODE",
      from: encodingType
    })
    const unicodeString = Encoding.codeToString(unicodeArray)
    return unicodeString
  }

  const parseFile = file => {
    Papa.parse(file, {
      preview: 50,
      header: false,
      complete: results => {
        formatCollumns(results.data);
      },
    });
  };

  function formatCollumns(errorReport) {
    let result = [];
    const keys = errorReport[0].map(item => item);
    setCurrentKeys(keys)
    errorReport.forEach((listas) => {

      const obj = {};
      for (let i = 0; i < listas.length; i++) {
        obj[keys[i]] = listas[i];
      }

      result.push(obj)
    })
    result.shift();
    setErrorData(result)
  }

  function downloadCSV() {
    let download_link = null;
    download_link = document.createElement("a");

    const today = format(new Date(), 'dd-MM-yyyy')

    download_link.download = `Relatório_de_Processamento_${today}.csv`;

    download_link.href = window.URL.createObjectURL(fileCSV);

    download_link.style.display = "none";

    document.body.appendChild(download_link);

    download_link.click()
  }


  const dynamicColumns = currentKeys.map(col => {
    return (
      <Column
        style={{ width: '300px' }}
        key={col}
        field={col}
        header={col}
      />
    );
  });

  // const dialogFooter = (
  //   <Paginator onPageChange={} rows={10} totalRecords={errorData.length} />
  // )

  return (
    <Dialog
      onHide={() => close()}
      visible
      header="Prévia do Relatório de Processamento"
      // footer={dialogFooter}
      loading={loading}
      pt={{
        root: ({ state }) => ({
          className: classNames('rounded-lg shadow-lg border-0', 'max-h-[90%] transform scale-100',
            'm-0 w-[90vw]',
            'dark:border dark:border-blue-900/40', {
            'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized
          })
        }),
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[85vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow max-h-screen": state.maximized
          })
        }),
      }}
      draggable={false}
    >
      {/* <ProgressSpinner status={loading} /> */}
      {/* <h4>Pré-visualização do Relatório de Erro </h4> */}
      <div className="justify-between grid gap-4 px-4">
        <div>
          {/* <h4><b>Prévia do Relatório de Processamento</b></h4> */}
          <small className="text-pink-500">*A prévia exibe apenas as 50 primeiras linhas<br />
            *Faça o download do arquivo para ver o relatório completo</small>
        </div>
        <div>
          <Button
            icon={<BiDownload fontSize="1.2rem" />}
            severity="info"
            rounded
            onClick={() => downloadCSV()}
            tooltip="Baixar em CSV"
            tooltipOptions={{ position: "bottom" }}
          />
        </div>
      </div>
      <div className="table-demo mt-6">
        <DataTable
          value={errorData}
          rows={10}
          paginator
          scrollHeight="45vh"
          emptyMessage="Nenhum relatório foi gerado ainda"
          scrollable
        >
          {dynamicColumns}
        </DataTable>
      </div>
    </Dialog>
  )
}

export default ErrorReportDialog